<dx-date-box
  type="time"
  [value]="value()"
  (onValueChanged)="onTimeSelected($event)"
  [disabled]="disabled()"
  [width]="width()"
  displayFormat="HH:mm"
  pickerType="rollers">
  <dxo-drop-down-options [title]="popupTitle()"></dxo-drop-down-options>
</dx-date-box>
